import { RouteProp } from '@react-navigation/native';

import { ReportSectionIndex, EmailTarget, Site, User } from '../../../utils/classes';
import { InjectedSite } from '../../../typing/types';
import { HomeStackParamList } from '../../../routes';

import retrieveMemberEmails from './retrieveMemberEmails';

/**
 * Get email targets from the auditor (single or team audit)
 */
export default function getEmailTargets(
  auth: any,
  profile: { email?: string },
  selectedSite: Site & InjectedSite,
  sections: ReportSectionIndex[],
  route: RouteProp<HomeStackParamList, 'SubmitReport'>
) {
  const emailTargets = selectedSite.emailTargets || [];
  let emails = emailTargets
    .filter(email => email)
    .map(
      (email): EmailTarget => ({
        email,
        enabled: true,
        status: 'unsent',
        setByAdmin: true
      })
    );
  if (profile.email && emailTargets.indexOf(profile.email) === -1) {
    emails.push({
      email: profile.email,
      enabled: true,
      status: 'unsent',
      setByAdmin: false
    });
  }
  if (selectedSite.isMultiSite) {
    emails = emails.concat(retrieveMemberEmails(auth, sections, route));
  }
  return emails;
}
